import $ from 'jquery';

const langSwitcherFlag = document.querySelector('.lang-switcher__flag');
const langSwitcherSelect = document.querySelector('.lang-switcher__select');

const langSwitcherData = {
    cs: {
        language: 'CS',
        flagCss: 'lang-switcher__flag--cs',
    },
    sk: {
        language: 'SK',
        flagCss: 'lang-switcher__flag--sk',
    },
    hu: {
        language: 'HU',
        flagCss: 'lang-switcher__flag--hu',
    },
    en: {
        language: 'EN',
        flagCss: 'lang-switcher__flag--en',
    },
    de: {
        language: 'DE',
        flagCss: 'lang-switcher__flag--de',
    },
};

const flagSelection = event => {
    langSwitcherFlag.classList.remove(
        'lang-switcher__flag--cs',
        'lang-switcher__flag--sk',
        'lang-switcher__flag--en',
        'lang-switcher__flag--de',
        'lang-switcher__flag--hu'
    );
    langSwitcherFlag.classList.add(`${langSwitcherData[event.target.value].flagCss}`);
};

langSwitcherSelect.addEventListener('click', event => {
    flagSelection(event);
});

langSwitcherSelect.addEventListener('change', event => {
    window.location.href = $(event.target).find('option:selected').attr('data-url');
});
